import { txsScenarioApi } from '@/apis';

export default {
  /**
   *
   * @param {Function} commit
   * @param {Function} dispatch
   */
  async initTxsScenario({ commit, dispatch }) {
    commit('reset');
    commit('setLoading', true);
    const requests = [dispatch('fetchScenarios'), dispatch('fetchSummary')];
    await Promise.all(requests);
    commit('setLoading', false);
  },
  /**
   *
   * @param {Function} commit
   */
  async fetchScenarios({ commit }) {
    try {
      const response = await txsScenarioApi.requestList();
      commit('addScenarios', response.data.scenarios);
    }
    catch (error) {
      commit('setError', error);
    }
  },
  /**
   *
   * @param {Function} commit
   */
  async fetchSummary({ commit }) {
    try {
      const response = await txsScenarioApi.requestSummary();
      commit('setSummary', response.data);
    }
    catch (error) {
      commit('setError', error);
    }
  },
};
